import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles, Shield, Heart, HelpCircle } from "lucide-react";
import heroImage from "@/assets/hero-mindfulme.jpg";

const HeroSection = () => {
  return (
    <section id="hero" className="pt-28 pb-20 md:pt-32 md:pb-28 bg-gradient-hero relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      {/* Floating Ambient Blobs */}
      <div className="absolute top-20 right-[15%] w-80 h-80 bg-accent/25 rounded-full blur-3xl animate-blob-float-slow"></div>
      <div className="absolute bottom-10 left-[10%] w-96 h-96 bg-secondary/20 rounded-full blur-3xl animate-blob-float-medium"></div>
      <div className="absolute top-40 left-[40%] w-64 h-64 bg-primary-light/10 rounded-full blur-3xl animate-pulse-slow"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div className="text-center lg:text-left text-white">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-5 py-2 mb-8 animate-slide-up shadow-lg shadow-primary-dark/10">
              <Sparkles className="w-4 h-4 text-accent-light animate-pulse" />
              <span className="text-sm font-semibold tracking-wide">Platform Kesehatan Mental #1 di Indonesia</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-none mb-8 animate-slide-up">
              Ruang Aman untuk{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-light via-white to-secondary-light">
                Pulih & Bertumbuh
              </span>
            </h1>

            <p className="text-lg md:text-xl text-white/85 mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed font-medium animate-slide-up">
              MindfulMe adalah platform kesehatan mental terpadu di Indonesia yang menghadirkan
              pendampingan psikologis dan bantuan hukum bagi mereka yang membutuhkan ruang aman
              untuk bersuara tanpa stigma.
            </p>

            <div className="flex flex-col sm:flex-row gap-5 justify-center lg:justify-start animate-slide-up">
              <Button 
                variant="hero" 
                size="lg" 
                className="group text-lg px-8 py-6 rounded-2xl shadow-xl shadow-primary-dark/25 hover:shadow-2xl hover:shadow-primary-dark/30 hover:scale-[1.03] transition-all duration-300"
                onClick={() => window.open('https://app-mindfulme.pusatandalan.com/', '_blank')}
              >
                Buat Pengaduan
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>

            <div className="mt-12 flex flex-wrap items-center justify-center lg:justify-start gap-6 text-sm font-semibold text-white/90">
              <div className="flex items-center gap-2.5 bg-white/5 backdrop-blur-sm px-6 py-3 rounded-xl border border-white/10 shadow-sm">
                <Shield className="w-4 h-4 text-secondary-light" />
                <span>100% Privasi Terjamin</span>
              </div>
              <div className="flex items-center gap-2.5 bg-white/5 backdrop-blur-sm px-6 py-3 rounded-xl border border-white/10 shadow-sm">
                <Heart className="w-4 h-4 text-accent-light" />
                <span>Dukungan 24/7</span>
              </div>
            </div>
          </div>

          {/* Hero Image Component */}
          <div className="relative lg:pl-10">
            <div className="relative p-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl shadow-2xl transition-all duration-500 hover:scale-[1.01] hover:border-white/30">
              <img
                src={heroImage}
                alt="MindfulMe - Platform Konsultasi Psikolog Online untuk Gen Z Indonesia"
                className="w-full h-auto rounded-2xl object-cover shadow-inner"
              />
              
              {/* Floating Widgets */}
              <div className="absolute -top-6 -left-6 bg-white/95 backdrop-blur-md border border-border/40 p-4 rounded-2xl shadow-xl flex items-center gap-3 animate-blob-float-slow max-w-[200px] hover:scale-105 transition-transform duration-300">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Heart className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground font-semibold">Layanan</p>
                  <p className="text-sm font-bold text-foreground">50+ Psikolog</p>
                </div>
              </div>

              <div className="absolute -bottom-6 -right-6 bg-white/95 backdrop-blur-md border border-border/40 p-4 rounded-2xl shadow-xl flex items-center gap-3 animate-blob-float-medium max-w-[200px] hover:scale-105 transition-transform duration-300">
                <div className="w-10 h-10 rounded-xl bg-secondary/10 flex items-center justify-center flex-shrink-0">
                  <Sparkles className="w-5 h-5 text-secondary" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground font-semibold">Respon</p>
                  <p className="text-sm font-bold text-foreground">24/7 Chat</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;